import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

const SentryConfig = {
    init(environment, url) {
        if (
            environment.toLowerCase() != 'development' &&
            environment.toLowerCase() != 'test'
        ) {
            Sentry.init({
                dsn: url,
                integrations: [
                    new Integrations.Vue({ Vue, attachProps: true })
                ],
                environment: environment
            });
        }
    }
};

export default SentryConfig;
